import React, { PureComponent } from 'react'
import { Cell } from 'react-sticky-table'
import { Icon, Text, CopyToClipboard } from 'components'

import './Player.css'

export function Player({ name, nickname, code, investment, hideImage, className }) {
    const { engine, gearbox, wheels } = investment || {}
    return (
        <Cell>
            <div className={`Player flex col-stretch ${className}`}>
                <div className="ST-Cell-race__header flex row-stretch-top">
                    <div className="Player-user flex col-center-left">
                        <h3 className="Player-user--name">{nickname}</h3>
                        <h4 className="Player-user--username">{name}</h4>
                        {!!code && (
                            <CopyToClipboard id="gamecode" textToCopy={code} placement="right">
                                <Text tag="span" className="Player-clipboard--text">
                                    {code}
                                </Text>
                                <Icon name="copy" className="Player-clipboard--icon" />
                            </CopyToClipboard>
                        )}
                    </div>
                    {!hideImage && <Icon name="race" className="Player-car" />}
                </div>

                {!!investment && (
                    <div className="ST-Cell-race__body">
                        {!!engine && (
                            <div className="ST-Cell-race__row flex row-stretch-center">
                                <span className="Player-label">Engine:</span>
                                <span className="Player-value">
                                    {engine.type} ({engine.units})
                                </span>
                            </div>
                        )}
                        {!!gearbox && (
                            <div className="ST-Cell-race__row flex row-stretch-center">
                                <span className="Player-label">Gearbox:</span>
                                <span className="Player-value">
                                    {gearbox.type} ({gearbox.units})
                                </span>
                            </div>
                        )}
                        {!!wheels && (
                            <div className="ST-Cell-race__row flex row-stretch-center">
                                <span className="Player-label">Wheels:</span>
                                <span className="Player-value">
                                    {wheels.type} ({wheels.units})
                                </span>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </Cell>
    )
}



// WEBPACK FOOTER //
// src/pages/MC/Game/Player/Player.js